import { colorInfoBg, colorBorder, colorIcon, colorWhite, colorSuccessActive } from './index';

export const iconActiveRoundConfig = {
  fontSize: '14px',
  height: '36px',
  width: '36px',
  color: colorWhite,
  background: colorSuccessActive,
  justifyContent: 'center',
  borderRadius: '40px'
};

export const iconDisabledRoundConfig = {
  fontSize: '14px',
  height: '36px',
  width: '36px',
  color: colorIcon,
  background: colorInfoBg,
  border: `1px solid ${colorBorder}`,
  justifyContent: 'center',
  borderRadius: '40px'
};
